export default __webpack_public_path__ + "9222cc72f541393c330572527e99ed8d.jpg";